// extracted by mini-css-extract-plugin
export default {"Index":"error_Index__MbhUq","Card":"error_Card__6evK1","nonMobileErrorImg":"error_nonMobileErrorImg__Rkkyj","mobileErrorImg":"error_mobileErrorImg__2VAet"};